<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Add Invoice</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content class="relative">
  @if (fileName() && !fileDeleted() && !invoiceFiles()?.length) {
    <div
      class="absolute right-0 result flex items-center px-15 py-10 mr-20 mt-5 bold subtitle-2 bg-wild-sand"
      @fadeSlideUpDown>
      <mat-icon class="size-18! text-18! mr-5 mt-[2px]">check_circle</mat-icon>
      EstImage found your Invoice
    </div>
  }
  <mat-tab-group
    animationDuration="0ms"
    class="add-invoice-tab"
    [selectedIndex]="data?.selectedIndex"
    (selectedTabChange)="selectedIndex = $event.index">
    <mat-tab #fromFile>
      <ng-template mat-tab-label>
        <div [ngClass]="{ 'text-boulder subtitle-1': !fromFile.isActive, 'text-red title-1': fromFile.isActive }">
          Import Invoice
        </div>
      </ng-template>
      <div class="pt-10 import-container-file border-0! border-t! border-charcoal-80! border-solid!">
        @if (fileName()) {
          <section class="file-box" @fadeSlideUpDown>
            <div class="file-container">
              <div class="delete-button-container">
                <mat-icon svgIcon="description"></mat-icon>
                <div>
                  <div class="received-date text-charcoal-10">
                    {{ lastModified() / 1000 | dateepoch: timezone() }} {{ lastModified() / 1000 | time: timezone() }}
                  </div>
                  <div class="file-name subtitle-2">
                    <span class="extra-margin">File</span>
                    <span class="subtitle-1 bold display-ellipsis">{{ fileName() }}</span>
                  </div>
                </div>
              </div>
              <button
                type="button"
                matButton="elevated"
                class="charcoal-button w-36! min-w-36! p-0!"
                [disabled]="pendingImages()"
                (click)="deleteFile(invoiceInput)">
                <mat-icon class="m-0!">delete_forever</mat-icon>
              </button>
            </div>
            @if (imageFiles()?.length) {
              <mat-divider @fadeInOut class="mt-10!" />
            }
            @if (pendingImages()) {
              <mat-progress-bar mode="indeterminate" class="my-20" />
            }
            @if (imageFiles()?.length) {
              <mat-checkbox @fadeInOut [checked]="uploadImages" (change)="uploadImages = $event.checked">
                EstImage found {{ imageFiles()?.length | i18nPlural: imagesPluralMapping }} that can be uploaded along
                with the invoice. Import these as well?
              </mat-checkbox>
            }
          </section>
        }
        @if (selectedIndex < 1) {
          <app-import-file-from-disk
            @fadeSlideUpDown
            (setFile)="setFileFromHandler($event)"
            (setImages)="setImages($event)"
            [rego]="data?.rego"
            [type]="data?.type"
            [fileDeleted]="fileDeleted()"
            [xmlFiles]="importInvoiceFiles" />
        }
        @if (!fileName()) {
          <div @fadeInOut class="button-container">
            <button matButton="elevated" class="charcoal-button" (click)="invoiceInput.click()">BROWSE</button>
          </div>
        }
        <input #invoiceInput (change)="importInvoice(invoiceInput)" [hidden]="true" accept="text/xml" type="file" />
      </div>
    </mat-tab>
    <mat-tab #fromQuotes>
      <ng-template mat-tab-label>
        <div
          [ngClass]="{
            'text-boulder subtitle-1': !fromQuotes.isActive,
            'text-red title-1': fromQuotes.isActive
          }">
          Invoice From Quotes
        </div>
      </ng-template>
      <div class="pt-10 border-0! border-b! border-charcoal-80! border-solid!">
        @for (quote of quotes; track quote) {
          <section
            @fadeInOut
            class="quote-list-grid text-charcoal-10 border-0! border-t! border-charcoal-80! border-solid!">
            <div>
              @if (quote.date) {
                <div @fadeInOut class="received-date text-charcoal-10">
                  {{ quote.date | dateepoch: timezone() }} {{ quote.date | time: timezone() }}
                </div>
              }
              <div class="inline-flex items-center">
                {{ quote.document.original ? 'Quote' : 'Supplement' }}
                @if (quote.document.supplementNumber > 0) {
                  <span class="ml-10">{{ quote.document.supplementNumber }}</span>
                }
                <h5 class="ml-10">{{ quote.document.quoteNumber }}</h5>
                @if (quote.assessed) {
                  <div @fadeInOut class="ml-10" appHighlightStatus="ASSESSED">ASSESSED</div>
                }
              </div>
            </div>
            <div>
              <div class="body-2">Assessed</div>
              <div class="subtitle-2">$ {{ quote.document.assessedTotal | number: '1.2-2' }}</div>
            </div>
          </section>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
  <form [formGroup]="invoiceForm">
    <div class="inline-flex w-full">
      <mat-form-field class="w-[460px] mt-20 flex-1">
        <mat-label>Invoice Number</mat-label>
        <input formControlName="invoiceNumber" matInput required />
        @if (invoiceNumber.hasError('required')) {
          <mat-error> Invoice Number is <strong>required</strong> </mat-error>
        }
        @if (invoiceNumber.hasError('duplicateInvoice')) {
          <mat-error> This invoice number is already associated with this job </mat-error>
        }
      </mat-form-field>
    </div>
    @if (selectedIndex === 1) {
      <section class="invoice-section" @fadeSlideUpDown>
        <div class="bg-charcoal py-[7px] px-20 text-white items-center border-charcoal-50! mt-[1px]">
          <span class="body-2">Totals</span>
        </div>
        <div class="bg-neut-90 py-[7px] px-20 grid grid-cols-[1fr_20px_150px] items-center">
          <span class="body-2">Invoice Subtotal</span>
          <span class="text-center">$</span>
          <span class="text-right subtitle-2">{{ assessedSubTotalInvoice | number: '1.2-2' }}</span>
        </div>
        <div class="bg-neut-90 py-[7px] px-20 grid grid-cols-[1fr_20px_150px] items-center mt-[1px]">
          <span class="body-2">GST</span>
          <span class="text-center">$</span>
          <span class="text-right subtitle-2">{{ assessedGSTTotalInvoice | number: '1.2-2' }}</span>
        </div>
        @if (!data.lastInvoice || (data.lastInvoice?.isFirstInvoice && data.lastInvoice?.status === 'REJECTED')) {
          <div
            class="bg-neut-90 py-10 px-20 grid grid-cols-[1fr_20px_150px] items-center border-t! border-0! border-solid! border-charcoal-50!">
            <span class="body-2 font-bold!">Invoice Total</span>
            <span class="text-center font-bold!">$</span>
            <span class="text-right font-bold! subtitle-2">{{ assessedTotalInvoice | number: '1.2-2' }}</span>
          </div>
        }
        @if (!data.lastInvoice || (data.lastInvoice?.isFirstInvoice && data.lastInvoice?.status === 'REJECTED')) {
          <div class="bg-neut-90 py-[7px] px-20 grid grid-cols-[1fr_20px_150px] items-center mt-[1px]">
            <span class="body-2">Excess</span>
            <span class="text-center">{{ !data.excessType ? '$' : '' }}</span>
            <span class="text-right subtitle-2">{{
              !data.excessType ? (data.excess | number: '1.2-2') : data.excessType
            }}</span>
          </div>
          <div class="bg-neut-90 py-5 pl-20 pr-10 grid grid-cols-[1fr_20px_150px] gap-10 items-center mt-[1px]">
            <span class="body-2">Owner Contribution</span>
            <span class="text-center">$</span>
            <mat-form-field class="no-validation xs">
              <input
                matInput
                class="text-right subtitle-2"
                formControlName="ownerContribution"
                formatInputNumber
                minDecimals="2"
                maxDecimals="2" />
            </mat-form-field>
          </div>
        }
        <div
          class="bg-charcoal-95 py-10 px-20 grid grid-cols-[1fr_20px_150px] items-center border-t! border-0! border-solid! border-charcoal-50!">
          <span class="body-2 font-bold!">Total Payable</span>
          <span class="text-center font-bold!">$</span>
          <span class="text-right font-bold! subtitle-2">{{ invoiceTotal() | number: '1.2-2' }}</span>
        </div>
      </section>
    }
  </form>
</div>
<mat-divider class="mx-20!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close [disabled]="invoiceForm.disabled">
    CANCEL
  </button>
  <button
    matButton="elevated"
    class="red-button"
    type="submit"
    [disabled]="
      invoiceForm.disabled ||
      invoiceForm.invalid ||
      invoiceForm.pristine ||
      pending() ||
      pendingImages() ||
      (fromFile.isActive && !fileName())
    "
    (click)="addInvoice(fromQuotes.isActive)">
    ADD INVOICE
  </button>
</mat-dialog-actions>
